import { RawModel } from "../rawModel/RawModel";
import { MeshConfig } from "./MeshConfig";
import { createMeshConfig } from "./MeshConfig";
import { ModelConfig } from "./ModelConfig";

export const getDefaultModelConfig = (raw: RawModel): ModelConfig => ({
    v: "1.0.0",
    elements: {},
    hiddenMeshes: [],
    meshAreas: {},
    meshConfig: raw.meshes.reduce((acc, mesh) => {
        acc[mesh.name] = createMeshConfig(mesh);
        return acc;
    }, {} as Record<string, MeshConfig>),
    materialSlots: {},
    materialMapping: {},
    meshGroups: {},
});
